export const environment = {
    production: true,
    APIEndpoint: '/api',
    splitPaymentAPI: '/api',
    //portal: '',
    scriptPortal: '',

    splitPaymentAPISwagger: 'http://localhost:8080/api/swagger-ui/index.html',
    APIEndpointSwagger: 'http://localhost:8080/api/swagger-ui/index.html',

    captchaSiteKey: '',
    exigeCaptcha: false,

    profile: 'offline'
};